import { makeStyles } from '@material-ui/core/styles';

export const useNotReceivedStyles = makeStyles(() => ({
  container: {
    borderTop: (props) => (props.mobile ? '' : '1px solid #6A148E'),
    backgroundColor: (props) => (props.mobile ? '' : '#F1F1F1'),
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
    width: '100%',
    padding: (props) => (props.mobile ? '' : '30px 70px'),
  },
  button: {
    width: 200,
    margin: '0 auto',
  },
  containerLoader: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0 auto',
  },
  loader: {
    height: 80,
    width: 80,
  },
}));
